<template>
 <div class="note">
  <div class="left">
   <div class="top">
    <span>Note list</span>
    <!-- <img src="../assets/img/Arrow-down.svg" alt=""> -->
   </div>
   <div class="bottom">
    <ul>
     <li v-for="item in lists" :key="item.key">
      <span> {{ item.title }} </span>
      <p> {{ item.content }} </p>
     </li>
    </ul>
   </div>
  </div>
  <div class="right">
   <div class="title">Sato Oki : Reading experience</div>
   <hr>
   <div class="date">
    <span>2019 / 9 / 9</span>
    <span>Friday 14:44</span>
   </div>
   <div class="content">
     <div class="pr">Introduction by Sato, a brief introduction to classic works <p></p> p Originally thought that this club was shared by some of Sato's designers, but the content is very easy. It uses 10 themes to connect the past design projects. It is not only the designers' own sharing, but also the cooperation review and feelings of many owners. . It is gentle and easy to read, and some of the more complicated parts are also accompanied by hand-painted instructions, which are quite cute. <p></p> The span of design works is also exaggerated – from international luxury goods to traditional snacks, from exhibition space to food packaging. From the design of "! (2013)", the nedo design office has two hundred and fifty projects at the same time each year. It is mentioned in the "Design of 2016" that the firm has developed 400 projects. At the same time! <p></p> Sato's addition, subtraction, multiplication and division</div>
    <img src="../assets/img/note.jpeg" alt="">
   </div>
   <div class="content reverse">
    <div class="pl">Introduction by Sato, a brief introduction to classic works <p></p> p Originally thought that this club was shared by some of Sato's designers, but the content is very easy. It uses 10 themes to connect the past design projects. It is not only the designers' own sharing, but also the cooperation review and feelings of many owners. . It is gentle and easy to read, and some of the more complicated parts are also accompanied by hand-painted instructions, which are quite cute. <p></p> The span of design works is also exaggerated – from international luxury goods to traditional snacks, from exhibition space to food packaging. From the design of "! (2013)", the nedo design office has two hundred and fifty projects at the same time each year. It is mentioned in the "Design of 2016" that the firm has developed 400 projects. At the same time! <p></p> Sato's addition, subtraction, multiplication and division</div>
    <!-- <div class="imgbox">
     <div class="top">
      <img src="../assets/img/note3.jpeg" alt="">
      <img src="../assets/img/note4.jpeg" alt="">
     </div>
     <div class="bottom">
      <img src="../assets/img/note5.jpeg" alt="">
      <img src="../assets/img/note6.jpeg" alt="">
     </div>
    </div> -->
    <img src="../assets/img/note2.jpeg" alt="">
   </div>
  </div>
 </div>
</template>

<style lang="sass" scoped>
.note
 display: flex
.left
 flex: 1
 .top
  background-color: #FCFAF9
  border-radius: 20px 0px 0px 0px
  padding: 9px 20px
  text-align: center
 .bottom
  background-color: rgba(#FCFAF9,.8)
  ul
   padding: 20px
   margin: 0
   li
    span
     font-size: 16px
    p
     font-size: 12px
     color: rgba(#221B16,0.6)
.right
 flex: 5
 background-color: #f1ebdb
 padding: 56px 32px
 overflow-y: auto
 .title
  font-size: 21px
  font-weight: bold
 .date
  display: flex
  justify-content: space-between
  margin-bottom: 30px
  span
   color: rgba(#221B16,.5)
   font-size: 13px
   &:nth-child(2)
    letter-spacing: 2px
 .content
  margin-bottom: 100px
  display: flex
  img
   width: 35%
 .content.reverse
  flex-direction: row-reverse
 .pr
  padding-right: 40px
 .pl
  padding-left: 40px
 .pl,.pr
  line-height: 1.6
  
</style>

<script>
export default {
 data() {
  return {
   lists: [
    {
     title: 'Daily',
     content: 'Everything is done'
    },
     {
     title: 'F2E Challenge',
     content: 'W9 olive note'
    },
     {
     title: 'Daily',
     content: 'Everything is done'
    },
     {
     title: 'Morden web',
     content: 'good share'
    },
     {
     title: 'Work record',
     content: 'Some nonsense'
    },
     {
     title: 'The idea pool in',
     content: 'Banner and website'
    },
     {
     title: 'Untitled',
     content: '..........'
    },
   ]
  }
 },
 methods: {
 },
}
</script>